const state = {
  loading: false,
  rules: {
    required: value => !!value || 'Campo obrigatório.',
  }
}

const getters = {
  loading: state => state.loading,
  rules: state => state.rules
}

const actions = {}

const mutations = {
  SET_LOADING: (state, loading) => state.loading = loading
}

export default {
  state,
  getters,
  actions,
  mutations
}